//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProjectAddedMessage } from './project-added.message';

@PresenterType(
{
    model: ProjectAddedMessage
})
@Component({
    selector: 'project-added-message-template',
    templateUrl: './project-added-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectAddedMessageTemplateComponent
{
    public data: WritableSignal<ProjectAddedMessage>;
    
    constructor() {
        this.data = signal<ProjectAddedMessage>(null);
    }
}